module.exports = __webpack_public_path__ + "static/008513-f0d48e0364f97f4750a757b3eec98215.jpg";